<template>
  <div>
    <b-badge class="background-color-cms text-white">{{ count }} Words</b-badge>
  </div>
</template>

<script>
import { splitWords } from "@/utils";

export default {
  props: {
    value: String,
  },
  computed: {
    count() {
      return splitWords(this.value).length;
    },
  },
};
</script>
